/**
 * A global namespace for aria-label.
 */
const ariaLabel = 'aria-label';
export default ariaLabel;
